import _export from '../internals/export.js';
import mathSign from '../internals/math-sign.js';

var $ = _export;
var sign = mathSign; // `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign

$({
  target: 'Math',
  stat: true
}, {
  sign: sign
});
